import axios from "axios";
import authHeader from "./auth-header";
import IClient from "../types/client.type";

const API_URL = `${process.env.REACT_APP_SERVER_URL}/client`;

export const getById = (id: string) => {
  return axios.get(API_URL + "/" + id, { headers: authHeader() });
};

export const create = (client: IClient) => {
  return axios.post(API_URL, client, { headers: authHeader() });
};

export const update = (id: number, client: IClient) => {
  return axios.put(API_URL + "/" + id, client, { headers: authHeader() });
};

export const getClients = (params: {}) => {
  return axios.get(API_URL, { params: params, headers: authHeader() });
};

export const getActiveClients = () => {
  return axios.get(API_URL + "/actives", { headers: authHeader() });
};
